module.exports = __webpack_public_path__ + "static/img/ui-ux-design.a5db89e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/ui-ux-design.svg
// module id = 0Fkp
// module chunks = 1